import Button from 'components/Form/Button';
import { CoreContext } from 'context/CoreContext';
import { useCallback, useContext, useEffect, useRef, useState } from 'react';
import { toast } from 'react-toastify';
import { ReadOne, Update, UpdateParecer } from 'services/banking';
import FormCore from '../../Form/Core';
import Wrapper from '../Wrapper';
import { AddProposalContainer, CompanyButtonContainer } from './styled';

export default function ModalCreditoErro({ id, reload }) {
  const { setModal, user } = useContext(CoreContext);
  const [loading, setLoading] = useState(false);
  const formRef = useRef(null);
  const formRefParecer = useRef(null);
  const [register, setRegister] = useState();

  const close = () => setModal(null);

  const init = useCallback(async () => {
    try {
      setLoading(true);
      const preData = await ReadOne(id);
      setRegister(preData);
    } catch (err) {
      toast.error('Erro ao buscar parecer da proposta');
    } finally {
      setLoading(false);
    }
  }, [id]);

  useEffect(() => {
    const getData = async () => {
      await init();

      if (register?.retorno_erro)
        formRef.current.setItem(register?.retorno_erro, 'retorno');
    };
    getData();

    // Desabilitado ESlint apenas para renderizar novamente apenas caso atualize "retorno_erro" e não o objeto todo
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [init, register?.retorno_erro]);

  const formTexto = [
    {
      ref: 'retorno',
      type: 'text',
      full: true,
      disabled: true,
      transparent: false,
      multiline: true,
      maxRows: 4,
      height: 100,
    },
  ];

  const formParecer = [
    {
      ref: 'obs',
      placeholder: 'Observações',
      full: true,
      required: true,
      disabled: false,
      maxRows: 4,
      multiline: true,
      height: 100,
    },
  ];

  const reenvia = async () => {
    try {
      setLoading(true);
      const form = await formRefParecer.current.getForm?.();
      if (!form) {
        return;
      }
      const newParecer = [
        ...register?.parecer,
        {
          usuario: user.id,
          data: new Date(),
          message: form.obs,
          origem: 'Crédito',
        },
      ];
      const payload = {
        status: 'aprovado',
        parecer: newParecer,
        proposta_financeira: register.proposta_financeira.id,
        proposta_bancaria: register.proposta_financeira.propostas_banco[0].id,
      };

      const result = await UpdateParecer({ data: payload }, register.id);
      if (result.status !== 200) {
        throw new Error(result?.error?.message);
      }
      if (result?.message !== 'ok') {
        toast.error(result?.message);
        close();
        reload?.();
      } else {
        toast.success('Reenviado para analise com sucesso!');
        close();
        reload?.();
      }
    } catch (err) {
      toast.error(err?.message || 'Erro ao salvar');
    } finally {
      setLoading(false);
    }
  };

  const reprova = async () => {
    try {
      setLoading(true);
      const form = await formRefParecer.current.getForm?.();
      if (!form) {
        return;
      }
      const newParecer = [
        ...register?.parecer,
        {
          usuario: user.id,
          data: new Date(),
          message: `MOTIVO REPROVAÇÃO: ${form.obs}`,
          origem: 'Crédito',
        },
      ];
      const payload = {
        status: 'recusado',
        parecer: newParecer,
        proposta_financeira: register.proposta_financeira.id,
        proposta_bancaria: register.proposta_financeira.propostas_banco[0].id,
      };
      const result = await UpdateParecer({ data: payload }, register.id);
      if (result.status !== 200) {
        throw new Error('Erro ao salvar');
      }
      toast.success('Registro salvo com sucesso!');
      close();
      reload?.();
    } catch (err) {
      toast.error(err?.response?.data?.message || 'Erro ao salvar');
    } finally {
      setLoading(false);
    }
  };

  const reanalisa = async () => {
    try {
      setLoading(true);
      const form = await formRefParecer.current.getForm?.();
      if (!form) {
        return;
      }
      const newParecer = [
        ...register?.parecer,
        {
          usuario: user.id,
          data: new Date(),
          message: form.obs,
          origem: 'Crédito',
        },
      ];
      const payload = { status: 'negocio', parecer: newParecer };
      const result = await Update({ data: payload }, register?.id);
      if (result.status !== 200) {
        throw new Error('Erro ao salvar');
      }
      toast.success('Registro salvo com sucesso!');
      close();
      reload?.();
    } catch (err) {
      toast.error(err?.response?.data?.message || 'Erro ao salvar');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Wrapper
      title={`Retorno da análise de crédito`}
      close={close}
      loading={loading}
    >
      <AddProposalContainer>
        <FormCore ref={formRef} formItems={formTexto} />
      </AddProposalContainer>
      <FormCore ref={formRefParecer} formItems={formParecer} />

      <CompanyButtonContainer>
        <Button color="secondary" onClick={reprova} nospace>
          Reprovar
        </Button>
        <Button color="blue" onClick={reanalisa} nospace>
          Reanalisar
        </Button>
        <Button color="green" onClick={reenvia} nospace>
          Reenviar
        </Button>
      </CompanyButtonContainer>
    </Wrapper>
  );
}
